var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentimentUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.968%",
    y1: "50%",
    x2: "50%",
    y2: "-38.581%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16DE85",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AB66",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.968 2.896A141.77 141.77 0 006 1.598s-3.052.538-6 1.28a.851.851 0 01.26-.467L2.537.327C2.734.147 3.12 0 3.399 0h5.166c.28 0 .666.146.863.327l2.277 2.084a.852.852 0 01.263.485zM5.33 9.93L.134 3.591A.808.808 0 010 3.355c2.586-.316 4.66-.48 4.66-.48.37-.032.67.218.67.558V9.93zm6.492-6.343l-5.196 6.34V3.433c0-.34.3-.59.671-.558 0 0 2.082.169 4.657.485a.807.807 0 01-.132.23z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    mask: "url(#c)",
    d: "M0 10.062h50.202V0H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentUp);
export default __webpack_public_path__ + "static/media/sentiment_up.6f8605017e145dc6b220ef8b2ed98fc7.svg";
export { ForwardRef as ReactComponent };